import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "express_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from "vue";
import useRoute from "@util/router";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import api from "@api/deliveryStation";
import MapSelectAddress from "@com/MapSelectAddress.vue";
export default {
  __name: 'TakeGoodsDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "自提点详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "自提点详情";
        getData();
      },
      add: () => {
        title = "新增自提点";
      },
      modify: () => {
        title = "修改自提点";
        getData();
      }
    });
    const formRef = ref(null);
    const data = reactive({
      id: null,
      name: null,
      address: null,
      lat: null,
      lng: null
    });

    function getData() {
      api.details(route.query().code, val => {
        data.id = val.id;
        data.name = val.name;
        data.address = val.address;
        data.lat = val.lat;
        data.lng = val.lng;
      });
    }

    const dataRules = {
      name: [{
        required: true,
        message: "请输入自提点名称",
        trigger: "blur"
      }],
      address: [{
        required: true,
        message: "请输入自提点地址",
        trigger: "blur"
      }]
    };

    function selectAddress(addr) {
      data.lat = addr.lat + "";
      data.lng = addr.lng + "";
      data.address = addr.address;
    }

    function save() {
      formRef.value.validate(valid => {
        if (valid) {
          if (data.lat == null || data.lng == null) {
            $msg.error("请选择地址");
            return;
          }

          $.handleCRU(urlQuery.type, {
            add: () => {
              api.add(data, () => {
                $msg.succ("添加成功");
                back();
              });
            },
            modify: () => {
              api.update(data, () => {
                $msg.succ("修改成功");
                back();
              });
            }
          });
        }
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: data,
            rules: dataRules,
            "label-width": "100px",
            class: "base_details_form",
            disabled: _unref(readOnly)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "自提点名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.name = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "自提点地址",
              prop: "address"
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
                modelValue: data.address,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.address = $event)
              }, null, 8, ["modelValue"]), _createVNode(MapSelectAddress, {
                class: "selectMap",
                position: [data.lng, data.lat],
                onSelect: selectAddress,
                disabled: _unref(readOnly)
              }, null, 8, ["position", "disabled"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !_unref(readOnly) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: save,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};